export default "__VITE_ASSET__BITKJRiV__"